import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAccept extends Layout {
    PanelCommodityAndEquipment: Panel;
    buttonConfirmAccept: Button;
    labelAccept: Label;
    labelAdditionalDetails: Label;
    labelDeliveryDate: Label;
    labelDeliveryDateTZ: Label;
    labelDistance: Label;
    labelDistanceCaption: Label;
    labelDistanceUnits: Label;
    labelEmailOfferConfirmation: Label;
    labelPickupDate: Label;
    labelPickupDateTZ: Label;
    labelSuccess: Label;
    labelThisLoadIsNoLongerAvailable: Label;
    panelAdditionalDetails: Panel;
    panelAvailable: Panel;
    panelDelivery: Panel;
    panelNotAvailable: Panel;
    panelPickup: Panel;
    panelSuccess: Panel;
    sourceCarrierAvailableOrders: DataSource;
    textboxCommodity: Textbox;
    textboxDestinationLocation: Textbox;
    textboxEquipmentDescr: Textbox;
    textboxEquipmentLength: Textbox;
    textboxLTL: Textbox;
    textboxOrderId: Textbox;
    textboxOriginLocation: Textbox;
    textboxRateCurrency: Textbox;
    textboxWeight: Textbox;
}
